import { useSelector } from 'react-redux';

import { getAccessCode, getRecorded } from 'store/modal/index';

export const useRecorded = () => useSelector(getRecorded);

export const useAccessCode = () => useSelector(getAccessCode);
